import { useCallback, useState } from 'react';

import type { fnGetFilteredProductLinks } from '@atlassian/global-shortcuts';
import type { ProductLink } from '@atlassian/navigation-bff-data-provider';

import type { ShortcutItemsConfig } from '../../../common/types';

interface UseInvitedAppProductLinksArgs {
	enabled: boolean;
	shortcutItemsConfig: ShortcutItemsConfig;
}

export const useInvitedAppProductLinks = ({
	enabled,
	shortcutItemsConfig,
}: UseInvitedAppProductLinksArgs) => {
	// store the invited app product links by apsKey in a state
	const [invitedAppProductLinks, setInvitedAppProductLinks] = useState<
		Record<string, ProductLink[]>
	>({});

	/**
	 * Handle updating the invited app product links by apsKey when the getFilteredProductLinks function is updated.
	 */
	const handleUpdateInvitedAppProductLinks = useCallback(
		(getFilteredProductLinks: fnGetFilteredProductLinks): void => {
			if (enabled && getFilteredProductLinks && typeof getFilteredProductLinks === 'function') {
				setInvitedAppProductLinks(
					Object.entries(shortcutItemsConfig).reduce<Record<string, ProductLink[]>>(
						(acc, [, config]) => {
							if (config.type === 'link' && config.apsKey && getFilteredProductLinks) {
								const { links } = getFilteredProductLinks(config.apsKey);
								acc[config.apsKey] = links;
							}
							return acc;
						},
						{},
					),
				);
			}
		},
		[enabled, shortcutItemsConfig],
	);

	return {
		invitedAppProductLinks,
		handleUpdateInvitedAppProductLinks,
	};
};
